import React from "react";

/**
 * PostViewCount - Component to display post view count
 *
 * @param {Object} props
 * @param {number} props.viewCount - Current view count
 * @param {Object} props.style - Optional custom styles
 */
const PostViewCount = ({ viewCount, style = {} }) => {
  // Hide completely when viewCount is null/undefined
  if (viewCount == null) {
    return null;
  }

  return (
    <div
      className="d-flex align-items-center gap-2"
      style={{
        color: "#7E8897",
        fontSize: "14px",
        fontWeight: 400,
        ...style,
      }}
    >
      {/* Eye Icon */}
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
      >
        <path
          d="M8 2C4.5 2 1.73 4.11 0 7C1.73 9.89 4.5 12 8 12C11.5 12 14.27 9.89 16 7C14.27 4.11 11.5 2 8 2ZM8 10.5C6.07 10.5 4.5 8.93 4.5 7C4.5 5.07 6.07 3.5 8 3.5C9.93 3.5 11.5 5.07 11.5 7C11.5 8.93 9.93 10.5 8 10.5ZM8 5C7.17 5 6.5 5.67 6.5 6.5C6.5 7.33 7.17 8 8 8C8.83 8 9.5 7.33 9.5 6.5C9.5 5.67 8.83 5 8 5Z"
          fill="#ffffff"
        />
      </svg>

      {/* Seen by Text */}
      <span
        className="react-text"
        style={{
          fontSize: "14px",
          fontWeight: 400,
          color: "#D0D8DF",
        }}
      >
        Seen by {viewCount}
      </span>
    </div>
  );
};

export default PostViewCount;
